/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `key` is invalid
 * @export
 * @class EnvInvalidKeyTypeError
 * @extends {Error}
 */
export class EnvInvalidKeyTypeError extends Error {
  /**
   * Creates an instance of EnvInvalidKeyTypeError
   * @param {string} message The Error `message`
   * @memberof EnvInvalidKeyTypeError
   */
  constructor(message) {
    super(message);
    this.name = `EnvInvalidKeyTypeError`;
  }
}

/**
 * Called when the type of a given `key` is invalid
 * @param {any} key The invalid `key`
 * @returns {never} never
 */
const throwEnvInvalidKeyTypeError = (key) => {
  throw new EnvInvalidKeyTypeError(
    stripIndent(`
    Expected the "key" to be of type String.
    Got: "${ctype(key)}".
    `),
  );
};

export default throwEnvInvalidKeyTypeError;
